import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { TNavigationTreeNode } from '../redux-store/navigation/navigation.models';
import { NavigationFacade } from '../redux-store/navigation/navigation.facade';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'lodash';

import { MOBILE_SCREEN_UTILS } from '@monorepo/ui';
import { AppNotificationUtilClass, TMMFeatureSet, UnifiedLoginService } from '@monorepo/services';
import { MOBILE_NODES } from '../constants/navigation-tree-list';

const MOBILE_LANDING_URL = '/ticket-management/summary';
const WEB_LANDING_URL = '/asset-management/machine-list';
const DEFAULT_LANDING_URL = '/home';
@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  isMobileScreen = false;
  constructor(
    private navigationInfoFacade: NavigationFacade,
    private router: Router,
    private APIHelper: AppNotificationUtilClass,
    private unifiedIdService: UnifiedLoginService,
  ) {
    this.isMobileScreen = MOBILE_SCREEN_UTILS.isMobileScreen();
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const navigationPromise = this.navigationInfoFacade.getNavigationInfoByFeature().pipe(
      map(({ navigationTreeList }) => {
        const routePath = route.routeConfig?.path;
        if (routePath) {
          this.#setSelectedNavigationItem(navigationTreeList, routePath);
        } else this.#redirectToLanding();
        return true;
      }),
      catchError((err) => {
        console.log('Error', err);
        return of(true);
      }),
    );
    return navigationPromise;
  }

  #redirectToLanding(isMobileRedirect?: boolean) {
    let landingSection;
    const featureSet = this.unifiedIdService.getFeatureSet() as TMMFeatureSet[];
    if (this.isMobileScreen) {
      landingSection = featureSet.includes('TICKET_SUMMARY') ? MOBILE_LANDING_URL : DEFAULT_LANDING_URL;
    } else {
      landingSection = featureSet.includes('MACHINE_VIEW') ? WEB_LANDING_URL : DEFAULT_LANDING_URL;
    }
    this.router.navigate([landingSection]);
    if (!isMobileRedirect) this.APIHelper.presentToastMM('Access Denied', 'Returning to homepage');
  }

  #setSelectedNavigationItem(navigationTreeList: TNavigationTreeNode[], currentPath: string) {
    const node = this.#seachNavigationTreeNode(navigationTreeList, currentPath);
    const mobileNodes = MOBILE_NODES;
    if (node) {
      if (this.isMobileScreen && !_.includes(mobileNodes, node.id)) {
        this.#redirectToLanding(true);
      } else {
        this.navigationInfoFacade.selectNavigationItem(node);
      }
    } else this.#redirectToLanding();
  }

  #seachNavigationTreeNode(nodeList: TNavigationTreeNode[], path: string): TNavigationTreeNode | null {
    for (const node of nodeList) {
      if (node?.url[0] === '/' + path) {
        return node;
      } else if (node.children?.length) {
        const found = this.#seachNavigationTreeNode(node.children, path);
        if (found !== null) {
          return found;
        }
      }
    }
    return null;
  }
}
